
import { httpRequest } from "../../http";

export class CommandNoteDetails {
    async run(notebookId: number, noteId: number) {  
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/${notebookId}/pages/${noteId}/`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return response;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}

